<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="12">
        <div class="grid-content">
          <el-autocomplete
            style="width:170px; margin-right:10px;"
            v-model="mac"
            :fetch-suggestions="querymacSearch"
            placeholder="MAC地址"
          ></el-autocomplete>

          <el-select style="width:170px; margin-right:10px;" v-model="cloud">
            <el-option
              v-for="platform in platforms"
              :key="platform"
              :label="platform"
              :value="platform"
            >
            </el-option>
          </el-select>

          <el-autocomplete
            v-if="cloud === '手动指定云服务IP'"
            style="width:200px; margin-right:10px;height:40px;"
            v-model="ip"
            :fetch-suggestions="queryipSearch"
            placeholder="手动指定云服务IP"
          ></el-autocomplete>

          <el-button
            @click="queryDevice"
            type="primary"
            size="medium"
            style="height:40px;"
            >查询设备</el-button
          >

          <el-button
            @click="openSecondChannel"
            type="primary"
            size="medium"
            style="margin-right:10px;height:40px;"
            :disabled="!openChannel"
            >第2维护通道</el-button
          >
        </div>
      </el-col>

      <el-col :span="12">
        <div class="grid-content">
          <el-tag
            type="danger"
            style="font-size:14px;font-weight:bold;height:40px;line-height:40px;margin-right:10px"
            >批量导出日志/文件/autop:</el-tag
          >

          <el-tooltip placement="bottom" :hide-after="3000">
            <div slot="content">可以改文件名，但文件格式必须是 xlsx</div>
            <el-button
              @click="downloadFile"
              type="info"
              class="el-icon-download"
              size="medium"
              style="height:40px;margin-right:10px"
              >下载 Excel 模板</el-button
            >
          </el-tooltip>

          <el-upload
            size="medium"
            style="display:inline-block;height:40px;margin-right:10px;"
            ref="upload"
            :action="uploadUrl()"
            :multiple="false"
            :limit="1"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :on-success="handleUploadSuccess"
            :file-list="fileList"
            :auto-upload="false"
            :headers="config"
          >
            <el-button
              slot="trigger"
              size="medium"
              type="info"
              style="height:40px;margin-right:10px;"
              >选取文件</el-button
            >
            <el-button
              style="height:40px;margin-right:10px;"
              size="medium"
              type="info"
              @click="submitUpload"
              >上传到服务器</el-button
            >
          </el-upload>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="24">
        <div class="grid-content">
          <el-tag
            size="medium"
            class="tag"
            type="primary"
            style="margin:0 15 0 0px;"
            >设备在线状态</el-tag
          >
          <i v-if="isOnline" class="el-icon-circle-check success"></i>
          <i v-else class="el-icon-circle-close error "></i>

          <el-tag
            size="medium"
            class="tag"
            type="primary"
            style="margin-right:15px;"
            >告警通道状态</el-tag
          >
          <el-switch
            v-model="isChannel"
            active-color="#67C23A"
            style="margin-right:15px;"
            :disabled="!isOnline"
            @change="changeChannel"
          ></el-switch>

          <el-tag
            size="medium"
            class="tag"
            type="primary"
            style="width:140px;margin-right:15px;"
            >接入服务器地址</el-tag
          >
          <label
            for="final.server_ip"
            style="margin:5px 0px;margin-right:15px;"
            >{{ final.server_ip }}</label
          >

          <el-tag
            size="medium"
            class="tag"
            type="primary"
            style="margin-right:15px;"
            >dclient_ver</el-tag
          >
          <label
            for="final.dclient_ver"
            style="margin:7px  0px;margin-right:15px;"
            >{{ final.dclient_ver }}</label
          >

          <el-tag
            size="medium"
            class="tag"
            type="primary"
            style="margin-right:15px;"
            >firmware</el-tag
          >
          <label
            for="final.firmware"
            style="margin:7px  0px;margin-right:15px;"
            >{{ final.firmware }}</label
          >
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="24">
        <div class="grid-content">
          <el-button
            @click="startCrab"
            type="primary"
            size="medium"
            :disabled="!isOnline"
            class="task"
            style="margin-right:15px;height:40px;"
            >开始抓包</el-button
          >
          <el-input
            v-model="crabtaskName"
            class="taskcontent"
            placeholder="任务名称"
          ></el-input>
          <el-input
            style="width:250px;margin-right:10px"
            v-model="crabtaskTime"
            class="taskcontent"
            placeholder="抓包时长（默认60s,最大180s)"
          ></el-input>
          <label style="margin-right:20px">秒</label>
          <el-button
            @click="stopCrab"
            type="primary"
            size="medium"
            :disabled="!stopBtn"
            class="task"
            >停止抓包</el-button
          >
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="24">
        <div class="grid-content">
          <el-button
            @click="exportLog"
            type="primary"
            size="medium"
            :disabled="!isOnline"
            class="task"
            style="margin-right:15px;height:40px;"
            >导出日志</el-button
          >
          <el-input
            v-model="logtaskName"
            class="taskcontent"
            placeholder="任务名称"
          ></el-input>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="24">
        <div class="grid-content">
          <el-button
            @click="exportAutop"
            type="primary"
            size="medium"
            :disabled="!isOnline"
            class="task"
            style="margin-right:15px;height:40px;"
            >导出autop</el-button
          >
          <el-input
            v-model="autotaskName"
            class="taskcontent"
            placeholder="任务名称"
          ></el-input>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="24">
        <div class="grid-content">
          <el-button
            @click="exportAnyfile"
            type="primary"
            size="medium"
            :disabled="!isOnline"
            class="task"
            style="margin-right:15px;height:40px;"
            >导出任意文件</el-button
          >
          <el-input
            v-model="anytaskName"
            class="taskcontent"
            placeholder="任务名称"
          ></el-input>
          <el-input
            v-model="fileUrl"
            class="taskcontent"
            style="width:60%;"
            placeholder="请输入设备上的文件完整路径"
          ></el-input>
        </div>
      </el-col>
    </el-row>

    <List
      url="tasks/"
      :title="title"
      :data="searchData"
      :tanle="tanle"
      :afterList="dealList"
      :update="updateList"
      :MultipleSel="true"
      @edit="edit"
      @download="download"
      @deletedata="deletedata"
    >
      <div slot="Fresh" style="float:right">
        <el-button @click="updateList++" type="primary" size="small"
          >刷新任务进度</el-button
        >
      </div>
    </List>
    <UpdateBox
      :initForm="updateForm"
      v-if="updateBlock"
      @close="close"
      @update="updateList++"
    ></UpdateBox>
  </div>
</template>
<script>
import List from "../components/common/List.vue";
import UpdateBox from "../components/TaskList/UpdateBox.vue";
import { Flags, flagsList } from "../components/Index/data.js";
import { Filetypes } from "../components/Index/data.js";

export default {
  props: {
    data: {}
  },
  components: {
    List,
    UpdateBox
  },
  data() {
    return {
      tanle: [
        { name: "create_time", label: "提交时间" },
        { name: "name", label: "任务名称" },
        { name: "mac", label: "MAC地址" },
        { name: "task_typeName", label: "任务类型" },
        { name: "flagName", label: "任务状态", status: "taskStatus" },
        { name: "username", label: "创建人" },
        { name: "file_upload_time", label: "完成时间" }
      ],
      cloud: "ucloud",
      mac: "",
      src: "",
      ip: "",
      fileUrl: "",
      crabtaskName: "",
      logtaskName: "",
      crabtaskTime: "60",
      autotaskName: "",
      anytaskName: "",
      updateList: 0,
      platforms: [
        "ucloud",
        "ecloud",
        "scloud",
        "sacloud",
        "t-healthcare",
        "test_kyy",
        "dev_sh",
        "dev_hz",
        "jcloud",
        "ccloud",
        "aucloud",
        "azcloud",
        "rucloud",
        "discreet",
        "discreet2025",
        "ecloud-tis",
        "dev",
        "test",
        "test84",
        "test_hz",
        "test_hager",
        "手动指定云服务IP"
      ],
      isOnline: false,
      isChannel: false,
      openChannel: true,
      stopBtn: false,
      customIP: false,
      flags: flagsList,
      updateBlock: false,
      updateForm: {},
      title: "今日任务列表",
      searchData: {
        begin_time: ""
      },
      ipRecords: [],
      macRecords: [],
      timer: "",
      final: {
        task_type: "",
        name: "",
        create_time: "",
        mac: "",
        cloud: "",
        dclient_ver: "",
        username: "",
        server_ip: "",
        location: "",
        firmware: ""
      },
      token: "",
      fileList: []
    };
  },
  mounted() {
    this.searchData.begin_time = this.changeDateDay(new Date());
    this.token = localStorage.getItem("token");
  },
  methods: {
    dealList(data) {
      for (let i in data) {
        data[i].flagName = Flags[data[i].flag];
        data[i].task_typeName = Filetypes[data[i].task_type];
        data[i].create_time = this.changeDate(data[i].create_time);
        // 格式化完成时间，如果不存在则显示为 "-"
        if (data[i].file_upload_time && data[i].file_upload_time !== null && data[i].file_upload_time !== '') {
          data[i].file_upload_time = this.changeDate(data[i].file_upload_time);
        } else {
          data[i].file_upload_time = "-";
        }
      }
      return data;
    },
    queryDevice() {
      if (this.mac.match(/[A-F0-9a-f]{12}/)) {
        this.macRecords = this.setmacIntoStorage();
        this.ipRecords = this.setipIntoStorage();
        this.$http["get"](
          "devices/",
          { mac: this.mac, cloud: this.cloud, ip: this.ip },
          data => {
            this.openChannel = true;
            this.final.mac = data.data.mac;
            this.final.cloud = data.data.cloud;
            this.final.dclient_ver = data.data.dclient_ver;
            this.final.server_ip = data.data.server_ip;
            this.final.firmware = data.data.firmware;
            //is_connect为1 在线
            if (data.data.is_connect) {
              this.isOnline = true;
              if (data.data.alarm_channel_status) {
                this.isChannel = true;
              }
            } else {
              this.$message("当前设备不在线，可以通过第2维护通道进行操作");
              this.isOnline = false;
              this.isChannel = false;
            }
          },
          () => {
            this.openChannel = true;
            this.isOnline = false;
            this.isChannel = false;
            this.final.mac = "";
            this.final.cloud = "";
            this.final.dclient_ver = "";
            this.final.server_ip = "";
            this.final.firmware = "";
          }
        );
      } else {
        this.$message.error("请输入正确格式的MAC地址");
      }
    },
    //queryString 为在框中输入的值
    querymacSearch(queryString, cb) {
      // 调用 callback 返回建议列表的数据
      const macRecords = JSON.parse(localStorage.getItem("macRecord"));
      const results = queryString
        ? macRecords.filter(this.createmacFilter(queryString))
        : macRecords;
      cb(results);
    },
    //queryString 为在框中输入的值
    queryipSearch(queryString, cb) {
      // 调用 callback 返回建议列表的数据
      const ipRecords = JSON.parse(localStorage.getItem("ipRecord"));
      const results = queryString
        ? ipRecords.filter(this.createipFilter(queryString))
        : ipRecords;
      cb(results);
    },
    createmacFilter(queryString) {
      return macRecord => {
        return (
          macRecord.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    createipFilter(queryString) {
      return ipRecord => {
        return (
          ipRecord.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    setmacIntoStorage() {
      // localStorage.removeItem("macRecord");
      const noArr = []; // 历史记录数组
      const value = this.mac;
      const macRecord = "macRecord";
      noArr.push({ value: value, type: macRecord });
      if (JSON.parse(localStorage.getItem(macRecord))) {
        // 判断是否已有xxx查询记录的localStorage
        if (localStorage.getItem(macRecord).indexOf(value) > -1) {
          // 判断是否已有此条查询记录，若已存在，则不需再存储
          return;
        }
        if (JSON.parse(localStorage.getItem(macRecord)).length >= 5) {
          const arr = JSON.parse(localStorage.getItem(macRecord));
          arr.pop();
          localStorage.setItem(macRecord, JSON.stringify(arr));
        }
        localStorage.setItem(
          macRecord,
          JSON.stringify(
            noArr.concat(JSON.parse(localStorage.getItem(macRecord)))
          )
        );
      } else {
        // 首次创建
        localStorage.setItem(macRecord, JSON.stringify(noArr));
      }
    },
    setipIntoStorage() {
      // localStorage.removeItem("ipRecord");
      const noArr = []; // 历史记录数组
      const value = this.ip;
      const ipRecord = "ipRecord";
      noArr.push({ value: value, type: ipRecord });
      if (JSON.parse(localStorage.getItem(ipRecord))) {
        // 判断是否已有xxx查询记录的localStorage
        if (localStorage.getItem(ipRecord).indexOf(value) > -1) {
          // 判断是否已有此条查询记录，若已存在，则不需再存储
          return;
        }
        if (JSON.parse(localStorage.getItem(ipRecord)).length >= 5) {
          const arr = JSON.parse(localStorage.getItem(ipRecord));
          arr.pop();
          localStorage.setItem(ipRecord, JSON.stringify(arr));
        }
        localStorage.setItem(
          ipRecord,
          JSON.stringify(
            noArr.concat(JSON.parse(localStorage.getItem(ipRecord)))
          )
        );
      } else {
        // 首次创建
        localStorage.setItem(ipRecord, JSON.stringify(noArr));
      }
    },
    changeChannel() {
      //打开告警通道
      if (this.isChannel) {
        this.$http["post"](
          "device_alarm_channels/",
          {
            operation: "open",
            mac: this.final.mac,
            cloud: this.final.cloud,
            server_ip: this.final.server_ip,
            is_close: "1"
          },
          () => {
            this.$baseNotice.message("开启成功");
          },
          () => {
            this.isChannel = !this.isChannel;
          }
        );
      }
      //关闭告警通道
      else {
        this.$http["post"](
          "device_alarm_channels/",
          {
            operation: "close",
            mac: this.final.mac,
            cloud: this.final.cloud,
            server_ip: this.final.server_ip,
            is_close: "0"
          },
          () => {
            this.$baseNotice.message("关闭成功");
          },
          () => {
            this.isChannel = !this.isChannel;
          }
        );
      }
    },
    close() {
      this.updateBlock = false;
    },
    edit(val) {
      this.updateBlock = true;
      this.updateForm = Object.assign({}, val);
    },
    deletedata(val) {
      let url = "tasks/" + val.id + "/";
      this.$http["delete"](url, () => {
        this.$baseNotice.message("删除成功");
        this.updateList++;
      });
    },
    startCrab() {
      if (this.crabtaskName) {
        this.stopBtn = true;
        if (this.crabtaskTime <= 180) {
          this.$http["post"](
            "tasks/",
            {
              task_type: "0",
              operation: "start_pcap",
              dclient_ver: this.final.dclient_ver,
              server_ip: this.final.server_ip,
              username: localStorage.getItem("username"),
              cloud: this.final.cloud,
              mac: this.final.mac,
              duration: this.crabtaskTime
            },
            () => {
              this.$baseNotice.message("开始抓包");
            }
          );
        } else {
          this.$message.error("抓包时长不得超过180s！");
        }
      } else {
        this.$message.error("请输入任务名称！");
      }
    },
    stopCrab() {
      this.stopBtn = false;
      this.$http["post"](
        "tasks/",
        {
          task_type: "0",
          operation: "stop_pcap",
          dclient_ver: this.final.dclient_ver,
          server_ip: this.final.server_ip,
          username: localStorage.getItem("username"),
          cloud: this.final.cloud,
          mac: this.final.mac,
          name: this.crabtaskName
        },
        () => {
          this.$baseNotice.message("停止抓包");
          this.updateList++;
        }
      );
    },
    openSecondChannel() {
      //打开第二通道
      let routeData = this.$router.resolve(
        "/secondChannel?mac=" + this.final.mac + "&cloud=" + this.final.cloud
      );
      window.open(routeData.href, "_blank");
      // this.$router.push({
      //   name: 'secondChannel',
      //   params: {
      //     mac: this.final.mac,
      //   }
      // })
    },
    exportLog() {
      if (this.logtaskName) {
        this.final.task_type = "1";
        this.final.name = this.logtaskName;
        this.final.create_time = this.changeDate(new Date());
        this.final.username = localStorage.getItem("username");
        this.$http["post"]("tasks/", this.final, () => {
          this.$baseNotice.message("创建成功");
          this.updateList++;
        });
      } else {
        this.$message.error("请输入任务名称！");
      }
    },
    exportAutop() {
      if (this.autotaskName) {
        this.final.task_type = "2";
        this.final.name = this.autotaskName;
        this.final.create_time = this.changeDate(new Date());
        this.final.username = localStorage.getItem("username");
        this.$http["post"]("tasks/", this.final, () => {
          this.$baseNotice.message("创建成功");
          this.updateList++;
        });
      } else {
        this.$message.error("请输入任务名称！");
      }
    },
    exportAnyfile() {
      if (this.anytaskName) {
        this.final.task_type = "3";
        this.final.name = this.anytaskName;
        this.final.create_time = this.changeDate(new Date());
        this.final.username = localStorage.getItem("username");
        this.final.location = this.fileUrl;
        this.$http["post"]("tasks/file-exporter/", this.final, () => {
          this.$baseNotice.message("创建成功");
          this.updateList++;
        });
      } else {
        this.$message.error("请输入任务名称！");
      }
    },
    download(val) {
      window.location.href = val.file_url;
    },
    changeDateDay(date) {
      var time = new Date(date);
      var nowYear = time.getFullYear().toString();
      var nowMonth = (time.getMonth() + 1).toString();
      var nowDay = time.getDate().toString();

      nowYear = this.timeAdd0(nowYear);
      nowMonth = this.timeAdd0(nowMonth);
      nowDay = this.timeAdd0(nowDay);
      return nowYear + "-" + nowMonth + "-" + nowDay;
    },
    changeDate(date) {
      var time = new Date(date);
      var nowYear = time.getFullYear().toString();
      var nowMonth = (time.getMonth() + 1).toString();
      var nowDay = time.getDate().toString();
      var nowHours = time.getHours().toString(); //获取当前小时数(0-23)
      var nowMin = time.getMinutes().toString(); //获取当前分钟数(0-59)
      var nowSeconds = time.getSeconds().toString(); //获取当前秒数(0-59)

      nowYear = this.timeAdd0(nowYear);
      nowMonth = this.timeAdd0(nowMonth);
      nowDay = this.timeAdd0(nowDay);
      nowHours = this.timeAdd0(nowHours);
      nowMin = this.timeAdd0(nowMin);
      nowSeconds = this.timeAdd0(nowSeconds);
      return (
        nowYear +
        "-" +
        nowMonth +
        "-" +
        nowDay +
        " " +
        nowHours +
        ":" +
        nowMin +
        ":" +
        nowSeconds
      );
    },
    timeAdd0(str) {
      if (str.length <= 1) {
        str = "0" + str;
      }
      return str;
    },
    downloadFile() {
      this.$http.http.defaults.responseType = "blob";
      this.$http.get("tasks/file-batch/", {}, res => {
        let blob = new Blob([res], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

        let eLink = document.createElement("a");
        eLink.download = "batch_device_task.xlsx";
        eLink.style.display = "none";
        eLink.href = URL.createObjectURL(blob);
        document.body.appendChild(eLink);
        eLink.click();
        URL.revokeObjectURL(eLink.href);
        document.body.removeChild(eLink);
      });
      this.$http.http.defaults.responseType = "json";
    },
    uploadUrl() {
      return this.$http.host + "tasks/file-batch/";
    },
    submitUpload() {
      this.$refs.upload.submit();
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleUploadSuccess(res, file, fileList) {
      console.log(file, fileList);
      let messageType = "success";
      if (res.code === 201) {
        messageType = "success";
      } else {
        messageType = "error";
      }
      this.$message({ type: messageType, message: res.msg });
    }
  },
  computed: {
    config() {
      return { Authorization: "JWT " + this.token };
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.stopBtn === true) {
      this.$msgbox({
        title: "提示",
        message: "抓包任务正在进行中，离开则会丢失！",
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      })
        .then(() => {
          next();
        })
        .catch(() => {
          next(false);
          document.getElementById("task").click();
        });
    } else {
      next();
    }
  }
};
</script>
<style lang="less" scoped>
.tag {
  height: 36px;
  width: 120px;
  line-height: 36px;
  font-size: 14px;
  background-color: #d7dbe0;
  color: #303133;
  margin-right: 10px;
  padding: 0px 16px;
  text-align: center;
}
.error {
  font-size: 25px;
  color: #606266;
  margin-top: 5px;
  margin-left: 10px;
  margin-right: 20px;
}
.success {
  font-size: 25px;
  color: #67c23a;
  margin-top: 5px;
  margin-left: 10px;
  margin-right: 20px;
}
.task {
  width: 120px;
  margin-right: 20px;
  // margin-top: 15px;
}
.taskcontent {
  width: 300px;
  margin-right: 20px;
  // margin-top: 15px;
}
.input {
  border-radius: 5px;
  border: 1px solid #ff0000;
}

// el-分栏的样式
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

// el-提示信息的样式
.box {
  width: 400px;

  .top {
    text-align: center;
  }

  .left {
    float: left;
    width: 60px;
  }

  .right {
    float: right;
    width: 60px;
  }

  .bottom {
    clear: both;
    text-align: center;
  }

  .item {
    margin: 4px;
  }

  .left .el-tooltip__popper,
  .right .el-tooltip__popper {
    padding: 8px 10px;
  }
}
</style>
